import React, { useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import Login from './components/Login';
import Layout from './components/Layout';

function App() {
  const [usuario, setUsuario] = useState(null);
  const [perfil, setPerfil] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUsuario(user);
        try {
          const docRef = doc(db, 'usuarios', user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const datos = docSnap.data();

            // MIGRACIÓN AUTOMÁTICA: si el perfil tiene rol como string (formato antiguo),
            // lo convertimos a array para el nuevo sistema RBAC.
            // Esto garantiza compatibilidad con usuarios creados antes de la sesión 14.
            if (datos.rol && !datos.roles) {
              datos.roles = datos.rol === 'admin' ? ['admin'] : ['empleado'];
            }

            // Garantizar que roles siempre es un array
            if (!datos.roles || !Array.isArray(datos.roles)) {
              datos.roles = ['empleado'];
            }

            setPerfil(datos);
          } else {
            // Usuario en Firebase Auth pero sin documento en Firestore
            // (puede pasar en desarrollo). Asignamos empleado por defecto.
            setPerfil({ roles: ['empleado'], nombre: user.email });
          }
        } catch (e) {
          console.error('Error cargando perfil:', e);
          setPerfil({ roles: ['empleado'], nombre: user.email });
        }
      } else {
        setUsuario(null);
        setPerfil(null);
      }
      setCargando(false);
    });
    return () => unsub();
  }, []);

  if (cargando) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0e0b24'
      }}>
        <div style={{ color: '#7B6FE8', fontSize: '1.2rem', fontFamily: 'DM Sans, sans-serif' }}>
          Cargando...
        </div>
      </div>
    );
  }

  if (!usuario || !perfil) {
    return <Login />;
  }

  return <Layout usuario={usuario} perfil={perfil} />;
}

export default App;
